module.exports = __webpack_public_path__ + "img/img4.19982a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lifeHome/img4.png
// module id = 397
// module chunks = 0